var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCounsel1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 158.807,
    height: 158.807,
    viewBox: "0 0 158.807 158.807",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M79.4,0A79.4,79.4,0,1,1,0,79.4,79.4,79.4,0,0,1,79.4,0Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1,
    transform: "translate(-211.383 -272.614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2329",
    "data-name": "Group 2329",
    transform: "translate(252.383 307.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3473",
    "data-name": "Path 3473",
    d: "M258.972,312.164a6.589,6.589,0,0,0-6.589,6.587V387.2a6.589,6.589,0,0,0,6.589,6.589H284V312.164Z",
    transform: "translate(-252.383 -304.52)",
    fill: "#c49a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3474",
    "data-name": "Path 3474",
    d: "M296.949,312.164H271.2v81.628h25.746a6.589,6.589,0,0,0,6.589-6.589V318.751A6.589,6.589,0,0,0,296.949,312.164Z",
    transform: "translate(-239.586 -304.52)",
    fill: "#b0875a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_907",
    "data-name": "Rectangle 907",
    width: 26.663,
    height: 74.495,
    transform: "translate(4.954 10.042)",
    fill: "#6d6e71"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_908",
    "data-name": "Rectangle 908",
    width: 27.38,
    height: 74.495,
    transform: "translate(31.617 10.042)",
    fill: "#56585d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_909",
    "data-name": "Rectangle 909",
    width: 25.511,
    height: 71.666,
    transform: "translate(6.106 11.499)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_910",
    "data-name": "Rectangle 910",
    width: 26.228,
    height: 71.666,
    transform: "translate(31.617 11.499)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3475",
    "data-name": "Path 3475",
    d: "M265.678,311.488v2.118a2.731,2.731,0,0,0,2.732,2.732h6.55v-4.85Z",
    transform: "translate(-243.343 -304.98)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3476",
    "data-name": "Path 3476",
    d: "M271.2,311.488v4.85h7.268a2.731,2.731,0,0,0,2.732-2.732v-2.118Z",
    transform: "translate(-239.586 -304.98)",
    fill: "#a2a7ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3477",
    "data-name": "Path 3477",
    d: "M265.293,312.749a2.58,2.58,0,0,0-2.58,2.58v.3a2.58,2.58,0,0,0,2.58,2.58h11.682v-5.463Z",
    transform: "translate(-245.359 -304.122)",
    fill: "#939598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3478",
    "data-name": "Path 3478",
    d: "M283.6,312.749H271.2v5.463h12.4a2.58,2.58,0,0,0,2.58-2.58v-.3A2.58,2.58,0,0,0,283.6,312.749Z",
    transform: "translate(-239.586 -304.122)",
    fill: "#7b7e84"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2328",
    "data-name": "Group 2328",
    transform: "translate(12.964 22.37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2325",
    "data-name": "Group 2325"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3479",
    "data-name": "Path 3479",
    d: "M260.1,329.478h8.544V320.93H260.1Zm.632-7.914h7.281v7.281h-7.281Z",
    transform: "translate(-260.1 -320.93)",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_911",
    "data-name": "Rectangle 911",
    width: 6.902,
    height: 1.424,
    transform: "translate(11.751 3.368)",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_912",
    "data-name": "Rectangle 912",
    width: 19.371,
    height: 1.424,
    transform: "translate(18.653 3.368)",
    fill: "#686c71"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2326",
    "data-name": "Group 2326",
    transform: "translate(0 21.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3480",
    "data-name": "Path 3480",
    d: "M260.1,342.173h8.544v-8.548H260.1Zm.632-7.914h7.281v7.281h-7.281Z",
    transform: "translate(-260.1 -333.625)",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_913",
    "data-name": "Rectangle 913",
    width: 6.902,
    height: 1.424,
    transform: "translate(11.751 3.368)",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_914",
    "data-name": "Rectangle 914",
    width: 19.371,
    height: 1.424,
    transform: "translate(18.653 3.368)",
    fill: "#686c71"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2327",
    "data-name": "Group 2327",
    transform: "translate(0 42.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3481",
    "data-name": "Path 3481",
    d: "M260.1,354.868h8.544V346.32H260.1Zm.632-7.914h7.281v7.281h-7.281Z",
    transform: "translate(-260.1 -346.32)",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_915",
    "data-name": "Rectangle 915",
    width: 6.902,
    height: 1.424,
    transform: "translate(11.751 3.369)",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_916",
    "data-name": "Rectangle 916",
    width: 19.371,
    height: 1.424,
    transform: "translate(18.653 3.369)",
    fill: "#686c71"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3482",
    "data-name": "Path 3482",
    d: "M273.749,310.762a1.567,1.567,0,0,1,1.211-1.524v-1.6a3.151,3.151,0,0,0-2.8,3.126H268.41a2.731,2.731,0,0,0-2.732,2.732v.613h9.282v-1.821A1.567,1.567,0,0,1,273.749,310.762Z",
    transform: "translate(-243.343 -307.599)",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3483",
    "data-name": "Path 3483",
    d: "M281.2,313.509a2.731,2.731,0,0,0-2.732-2.732h-3.746a3.034,3.034,0,0,0-3.521-3.126v1.6a1.569,1.569,0,1,1,0,3.047v1.821h10Z",
    transform: "translate(-239.586 -307.614)",
    fill: "#686c71"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2330",
    "data-name": "Group 2330",
    transform: "translate(288.837 312.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3484",
    "data-name": "Path 3484",
    d: "M276.558,347.646c.8-.855,2.045-2.187,4.254-4.558l-3.486-2.375c-1.4,2.923-2.182,4.569-2.683,5.626Z",
    transform: "translate(-273.701 -290.055)",
    fill: "#00a79d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3485",
    "data-name": "Path 3485",
    d: "M293.353,315.881l3.626-5.322,4.6,7.033-2.618,3.842Z",
    transform: "translate(-260.979 -310.559)",
    fill: "#00a79d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3486",
    "data-name": "Path 3486",
    d: "M293.77,328.136l-6.728-4.583q-.653,1.021-1.289,2.026l6.6,4.5C292.827,329.438,293.3,328.793,293.77,328.136Z",
    transform: "translate(-266.146 -301.723)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3487",
    "data-name": "Path 3487",
    d: "M290.785,326.24c-4.408,7.089-8.506,14.152-14.725,24.4l3.822,2.6c7.261-9.537,12.334-15.935,17.319-22.631Z",
    transform: "translate(-272.737 -299.896)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3488",
    "data-name": "Path 3488",
    d: "M301.693,314.763a2.653,2.653,0,0,0-2.769-.413c-1.976.647-4.166,2.9-6.5,6.7-4.811,7.528-11.315,16.608-11.378,16.7,0,0,3.995.538,5.233-4.173,1.782-2.6,9.769-13.453,9.848-13.561a3.238,3.238,0,0,1,1.272-1c.346-.114.867-.156,1.381.761.423.754.85.8,1.136.709,1.139-.371,1.719-4.274,1.868-5.462l.018-.151Z",
    transform: "translate(-269.349 -308.108)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3489",
    "data-name": "Path 3489",
    d: "M292.988,329.26l-6.6-4.5c-.527.833-1.043,1.66-1.559,2.488l6.416,4.373Q292.115,330.446,292.988,329.26Z",
    transform: "translate(-266.777 -300.903)",
    fill: "#00a79d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3490",
    "data-name": "Path 3490",
    d: "M304.882,318.006q-3.379-2.306-6.76-4.608c-4.795,6.727-8.393,12.06-11.6,17.06l6.728,4.583C296.729,330.228,300.376,324.929,304.882,318.006Z",
    transform: "translate(-265.625 -308.628)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3491",
    "data-name": "Path 3491",
    d: "M275.024,344.062a7.589,7.589,0,0,0-.575,1.347,7.834,7.834,0,0,0-.368,2.092,10.139,10.139,0,0,0,1.613-1,9.919,9.919,0,0,0,1.245-1.131Z",
    transform: "translate(-274.082 -287.777)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3492",
    "data-name": "Path 3492",
    d: "M297.907,315.524l-10.131,14.923,3.046,2.077,10.254-14.893Z",
    transform: "translate(-264.77 -307.182)",
    fill: "#bcbec0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounsel1);
export default __webpack_public_path__ + "static/media/counsel1.1449c5e6f2ad6686e3dd1bdae7dc751e.svg";
export { ForwardRef as ReactComponent };